/* Get header and footer heights */
document.addEventListener("DOMContentLoaded", function () {
  var scroller = document.querySelector(".shopify-section--scrolling-text");

  var scrollerHeight = scroller.offsetHeight;

  document.documentElement.style.setProperty(
    "--scroller-height",
    scrollerHeight + "px"
  );
});
